"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMemoizedNullableTableConfig = exports.createNullableTableConfig = exports.peekEditedTableCellValue = exports.getTableCellValues = exports.getTableCellRow = void 0;
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const getTableCellRow = (e) => {
    return e.cell?.row?.original;
};
exports.getTableCellRow = getTableCellRow;
const getTableCellValues = (e) => {
    return e.cell?.row?.values;
};
exports.getTableCellValues = getTableCellValues;
const peekEditedTableCellValue = (e, id) => e.allEditedRows.find((aer) => aer.id === id);
exports.peekEditedTableCellValue = peekEditedTableCellValue;
const createNullableTableConfig = (config) => config.filter(util_1.isValue);
exports.createNullableTableConfig = createNullableTableConfig;
const useMemoizedNullableTableConfig = (config, deps) => {
    const _memoizedConfig = react_1.default.useMemo(() => config.filter(util_1.isValue), deps);
    return _memoizedConfig;
};
exports.useMemoizedNullableTableConfig = useMemoizedNullableTableConfig;
